import { join } from 'lodash';
var ControlActionCallGenerator = /** @class */ (function () {
    function ControlActionCallGenerator() {
    }
    ControlActionCallGenerator.prototype.generateCall = function (controlModel, layoutAction, isAsync, contextEntity, parentFieldFinder) {
        var args = layoutAction.metaArgs.map(function (arg) {
            return arg.resolve(controlModel, contextEntity, parentFieldFinder);
        });
        var generatedCall = "actions." + layoutAction.name + "(" + join(args, ',') + ")";
        return isAsync ? generatedCall + ' | async' : generatedCall;
    };
    return ControlActionCallGenerator;
}());
export { ControlActionCallGenerator };
//# sourceMappingURL=control-action-call.generator.js.map